var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftLucky"
  }, [_c('n-new-head'), _c('div', {
    staticClass: "nftLucky-body page-body"
  }, [_c('div', {
    staticClass: "nftLucky-main page-main"
  }, [_c('div', {
    staticClass: "nftLucky-draw",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucy-bg.jpg')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-body",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-title",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky_title.png')}) center top/auto 100% no-repeat`
    }
  }, [_vm._v("Shard Draw")]), _c('div', {
    staticClass: "nftLucky-draw-main"
  }, _vm._l(9, function (item, index) {
    return _c('div', {
      staticClass: "nftLucky-draw-item"
    }, [index !== 4 ? _c('div', {
      staticClass: "nftLucky-draw-item-main",
      style: {
        background: `url(${require(_vm.highlightIndex === index ? '@images/tapcoin/new/niceLucky/niceLucky-item-active-bg.png' : '@images/tapcoin/new/niceLucky/niceLucky-item-bg.png')}) center top/100% auto no-repeat`
      }
    }, [index == 3 ? _c('div', {
      staticClass: "nftLucky-draw-item-fail"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/CRY.png`),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "nftLucky-draw-item-reward"
    }, [_c('div', {
      staticClass: "nftLucky-draw-item-reward__label"
    }, [_vm._v("NFT Shards")]), _c('div', {
      staticClass: "nftLucky-draw-item-reward__img"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "nftLucky-draw-item-tag"
    }, [_vm._v("+99")])])])]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "nftLucky-draw-ship",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/ship-num.png')}) center top/auto 100% no-repeat`
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v("200")])]), _c('div', {
    staticClass: "nftLucky-draw-btns",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/niceLucky-bottom.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btn",
    on: {
      "click": _vm.startSpin
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btn-bg",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "nftLucky-draw-btn__title"
  }, [_vm._v("SPIN")]), _c('div', {
    staticClass: "nftLucky-draw-btn__price"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 222")]), _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 111")])])]), _c('div', {
    staticClass: "nftLucky-draw-btn",
    on: {
      "click": _vm.startSpin
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btn-bg",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/btn-2.png')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "nftLucky-draw-btn__title"
  }, [_vm._v("SPIN")]), _c('div', {
    staticClass: "nftLucky-draw-btn__price"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 222")]), _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 111")])])]), _c('div', {
    staticClass: "nftLucky-draw-btn",
    on: {
      "click": _vm.startSpin
    }
  }, [_c('div', {
    staticClass: "nftLucky-draw-btn-bg three",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/btn-1.png')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "nftLucky-draw-btn__title"
  }, [_vm._v("SPIN")]), _c('div', {
    staticClass: "nftLucky-draw-btn__price"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 222")]), _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/TAP.png`),
      "alt": ""
    }
  }), _vm._v(" 111")])])])])]), _c('div', {
    staticClass: "nftLucky-history"
  }, [_c('div', {
    staticClass: "history__title"
  }, [_vm._v("Draw History")]), _c('div', {
    staticClass: "history-list"
  }, _vm._l(10, function (_) {
    return _c('div', {
      staticClass: "history-item"
    }, [_c('div', {
      staticClass: "history-item__reward"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    }), _vm._v(" +2")]), _c('div', {
      staticClass: "history-item__price"
    }, [_vm._v("1000 TAPS")])]);
  }), 0)])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };